import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class PocAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'Poc';

	get(id) {
		let request = {
			url: `${this.getAPIUrl()}/${id}`
		};

		return httpClient.getAsync(request);
	}

	getAppLink() {
		let request = {
			url: `${this.getAPIUrl()}/app/link`
		};

		return httpClient.getAsync(request);
	}
	getAppRoles() {
		let request = {
			url: `${this.getAPIUrl()}/app/roles`
		};

		return httpClient.getAsync(request);
	}
}

export default new PocAPI();
